import NewPassword from "../components/NewPassword/NewPassword"

const NewPasswordContainer = () => {
    return <NewPassword/>
}

export default NewPasswordContainer